export default __webpack_public_path__ + "static/marketplacemobile-cc0893884fee16ee9c1024b550e52578.png";